export default "__VITE_ASSET__7K_k269o__"